import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEye, faPrint, faList, faThLarge, faSync, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './CocinaData.css';
import baseURL from '../../url';
import moneda from '../../moneda';
import Modal from 'react-modal';

export default function CocinaData() {
    const [pedidos, setPedidos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [vistaActual, setVistaActual] = useState('grid'); // 'grid' o 'list'
    const [filtroFecha, setFiltroFecha] = useState(new Date().toISOString().split('T')[0]);
    const [filtroEstado, setFiltroEstado] = useState('');
    const [pedidoExpandido, setPedidoExpandido] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);

    useEffect(() => {
        cargarPedidos();
    }, [filtroFecha, filtroEstado]);

    const cargarPedidos = () => {
        setLoading(true);
        let url = `${baseURL}/cocinaGet.php?fecha=${filtroFecha}`;
        
        if (filtroEstado) {
            url += `&estado=${filtroEstado}`;
        }

        fetch(url, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    const pedidosFiltrados = (data.data || []).filter(
                        item => item.entrega != "Reserva en Acomodación"
                    );
                    setPedidos(pedidosFiltrados);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar pedidos:', error);
                toast.error('Error al cargar pedidos');
                setLoading(false);
            });
    };

    const cambiarEstado = (idPedido, nuevoEstado) => {
        const payload = {
            orderId: idPedido,
            newEstadoCocina: nuevoEstado
        };

        fetch(`${baseURL}/cocinaUpdate.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    toast.success('Estado actualizado');
                    cargarPedidos();
                } else {
                    toast.error(data.error || 'Error al actualizar');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                toast.error('Error al actualizar estado');
            });
    };

    const eliminarDeCocina = (idPedido) => {
        Swal.fire({
            title: '¿Eliminar de cocina?',
            text: 'El pedido se quitará del panel de cocina',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/cocinaDelete.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ orderId: idPedido }),
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            Swal.fire('Eliminado', data.message, 'success');
                            cargarPedidos();
                        } else {
                            toast.error(data.error);
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        toast.error('Error al eliminar');
                    });
            }
        });
    };

    const abrirModal = (pedido) => {
        setPedidoSeleccionado(pedido);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
        setPedidoSeleccionado(null);
    };

    const imprimirPedido = (idPedido) => {
        Swal.fire({
            title: '¿Qué deseas imprimir?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Comanda',
            denyButtonText: 'Factura',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                window.open(`${baseURL}/cocinaPrint.php?orderId=${idPedido}&type=comanda`, '_blank');
            } else if (result.isDenied) {
                window.open(`${baseURL}/cocinaPrint.php?orderId=${idPedido}&type=factura`, '_blank');
            }
        });
    };

    const toggleExpandir = (idPedido) => {
        setPedidoExpandido(pedidoExpandido === idPedido ? null : idPedido);
    };

    const getColorEstado = (estado) => {
        switch (estado) {
            case 'Pendiente':
                return '#ff9800';
            case 'En Preparación':
                return '#2196f3';
            case 'Terminado':
                return '#4caf50';
            default:
                return '#999';
        }
    };

    const agruparPorEstado = () => {
        const agrupado = {
            'Pendiente': [],
            'En Preparación': [],
            'Terminado': []
        };

        pedidos.forEach(pedido => {
            if (agrupado[pedido.estado_cocina]) {
                agrupado[pedido.estado_cocina].push(pedido);
            }
        });

        return agrupado;
    };

    const renderTarjeta = (pedido) => {
        const productos = JSON.parse(pedido.productos || '[]');
        const esExpandido = pedidoExpandido === pedido.idPedido;

        return (
            <div 
                key={pedido.idPedido}
                className='cocina-card'
                style={{ borderLeft: `4px solid ${getColorEstado(pedido.estado_cocina)}` }}
            >
                <div className='card-header'>
                    <span className='card-id'>Pedido #{pedido.idPedido}</span>
                    <span 
                        className='card-estado'
                        style={{ backgroundColor: getColorEstado(pedido.estado_cocina) }}
                        onClick={() => {
                            const estados = ['Pendiente', 'En Preparación', 'Terminado'];
                            const indiceActual = estados.indexOf(pedido.estado_cocina);
                            const nuevoEstado = estados[(indiceActual + 1) % estados.length];
                            cambiarEstado(pedido.idPedido, nuevoEstado);
                        }}
                    >
                        {pedido.estado_cocina}
                    </span>
                </div>

                <div className='card-info'>
                    <p><strong>Fecha:</strong> {new Date(pedido.createdAt).toLocaleString('es-ES')}</p>
                    <p><strong>Total:</strong> {moneda} {Number(pedido.total).toLocaleString('es-ES')}</p>
                    {pedido.descuento_aplicado && parseFloat(pedido.descuento_aplicado) > 0 && (
                        <p style={{ color: '#4CAF50', fontWeight: 'bold' }}>
                            <strong>✓ Cupón:</strong> {pedido.codigo} (-{moneda} {Number(pedido.descuento_aplicado).toLocaleString('es-ES')})
                        </p>
                    )}
                    <p><strong>Cliente:</strong> {pedido.nombre}</p>
                </div>

                <button className='btn-ver-mas' onClick={() => toggleExpandir(pedido.idPedido)}>
                    {esExpandido ? 'Ver menos' : 'Ver más'}
                    <FontAwesomeIcon icon={esExpandido ? faChevronUp : faChevronDown} />
                </button>

                {esExpandido && (
                    <div className='card-detalles'>
                        <h4>Productos:</h4>
                        {productos.map((item, index) => (
                            <div key={index} className='producto-item'>
                                <p><strong>{item.titulo}</strong> x {item.cantidad}</p>
                                {Array.isArray(item.items) && item.items.length > 0 && (
                                    <ul className='items-list'>
                                        {item.items.map((adicional, idx) => (
                                            <li key={idx}>+ {adicional.name}</li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        ))}
                        {pedido.nota && (
                            <div className='observaciones'>
                                <strong>Observaciones:</strong>
                                <p>{pedido.nota}</p>
                            </div>
                        )}
                    </div>
                )}

                <div className='card-actions'>
                    <button className='btn-action btn-delete' onClick={() => eliminarDeCocina(pedido.idPedido)}>
                        <FontAwesomeIcon icon={faTrash} /> Eliminar
                    </button>
                    <button className='btn-action btn-view' onClick={() => abrirModal(pedido)}>
                        <FontAwesomeIcon icon={faEye} /> Ver
                    </button>
                    <button className='btn-action btn-print' onClick={() => imprimirPedido(pedido.idPedido)}>
                        <FontAwesomeIcon icon={faPrint} /> Imprimir
                    </button>
                </div>
            </div>
        );
    };

    if (loading) {
        return <div className='loading'>Cargando pedidos...</div>;
    }

    const pedidosAgrupados = agruparPorEstado();

    return (
        <div className='cocina-container'>
            <ToastContainer />

            <div className='cocina-header'>
                <h2>Panel de Cocina</h2>
                <div className='header-actions'>
                    <button 
                        className={`btn-vista ${vistaActual === 'grid' ? 'active' : ''}`}
                        onClick={() => setVistaActual('grid')}
                    >
                        <FontAwesomeIcon icon={faThLarge} /> Cuadrícula
                    </button>
                    <button 
                        className={`btn-vista ${vistaActual === 'list' ? 'active' : ''}`}
                        onClick={() => setVistaActual('list')}
                    >
                        <FontAwesomeIcon icon={faList} /> Lista
                    </button>
                    <button className='btn-recargar' onClick={cargarPedidos}>
                        <FontAwesomeIcon icon={faSync} /> Recargar
                    </button>
                </div>
            </div>

            <div className='cocina-filtros'>
                <div className='filtro'>
                    <label>Fecha:</label>
                    <input 
                        type='date' 
                        value={filtroFecha}
                        onChange={(e) => setFiltroFecha(e.target.value)}
                    />
                </div>
                <div className='filtros-estado'>
                    <button 
                        className={`filtro-btn ${filtroEstado === '' ? 'active' : ''}`}
                        onClick={() => setFiltroEstado('')}
                        style={{ backgroundColor: '#555' }}
                    >
                        Todos
                    </button>
                    <button 
                        className={`filtro-btn ${filtroEstado === 'Pendiente' ? 'active' : ''}`}
                        onClick={() => setFiltroEstado('Pendiente')}
                        style={{ backgroundColor: '#ff9800' }}
                    >
                        Pendiente
                    </button>
                    <button 
                        className={`filtro-btn ${filtroEstado === 'En Preparación' ? 'active' : ''}`}
                        onClick={() => setFiltroEstado('En Preparación')}
                        style={{ backgroundColor: '#2196f3' }}
                    >
                        En Preparación
                    </button>
                    <button 
                        className={`filtro-btn ${filtroEstado === 'Terminado' ? 'active' : ''}`}
                        onClick={() => setFiltroEstado('Terminado')}
                        style={{ backgroundColor: '#4caf50' }}
                    >
                        Terminado
                    </button>
                </div>
            </div>

            {vistaActual === 'grid' ? (
                <div className='cocina-grid'>
                    {Object.entries(pedidosAgrupados).map(([estado, pedidosEstado]) => (
                        <div key={estado} className='columna-estado'>
                            <h3 className='columna-titulo' style={{ backgroundColor: getColorEstado(estado) }}>
                                {estado} ({pedidosEstado.length})
                            </h3>
                            <div className='columna-contenido'>
                                {pedidosEstado.length > 0 ? (
                                    pedidosEstado.map(pedido => renderTarjeta(pedido))
                                ) : (
                                    <p className='sin-pedidos'>Sin pedidos</p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className='cocina-list'>
                    {pedidos.length > 0 ? (
                        pedidos.map(pedido => renderTarjeta(pedido))
                    ) : (
                        <p className='sin-pedidos'>No hay pedidos para mostrar</p>
                    )}
                </div>
            )}

            {/* Modal de detalle */}
            <Modal
                isOpen={modalVisible}
                onRequestClose={cerrarModal}
                className='modal-detalle-pedido'
                overlayClassName='overlay-modal'
            >
                {pedidoSeleccionado && (
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h3>Detalle del Pedido #{pedidoSeleccionado.idPedido}</h3>
                            <button onClick={cerrarModal} className='btn-cerrar'>×</button>
                        </div>
                        <div className='modal-body'>
                            <div className='detalle-item'>
                                <strong>Cliente:</strong> {pedidoSeleccionado.nombre}
                            </div>
                            <div className='detalle-item'>
                                <strong>Teléfono:</strong> {pedidoSeleccionado.telefono}
                            </div>
                            <div className='detalle-item'>
                                <strong>Entrega:</strong> {pedidoSeleccionado.entrega}
                            </div>
                            <div className='detalle-item'>
                                <strong>Forma de Pago:</strong> {pedidoSeleccionado.payment_method_name || pedidoSeleccionado.pago || 'No especificado'}
                            </div>
                            {pedidoSeleccionado.payment_reference && (
                                <div className='detalle-item'>
                                    <strong>Referencia de Pago:</strong> {pedidoSeleccionado.payment_reference}
                                </div>
                            )}
                            {pedidoSeleccionado.descuento_aplicado && parseFloat(pedidoSeleccionado.descuento_aplicado) > 0 ? (
                                <>
                                    <div className='detalle-item'>
                                        <strong>Subtotal:</strong> {moneda} {(Number(pedidoSeleccionado.total) + Number(pedidoSeleccionado.descuento_aplicado)).toLocaleString('es-ES')}
                                    </div>
                                    <div className='detalle-item' style={{ color: '#4CAF50', fontWeight: 'bold' }}>
                                        <strong>Descuento ({pedidoSeleccionado.codigo}):</strong> -{moneda} {Number(pedidoSeleccionado.descuento_aplicado).toLocaleString('es-ES')}
                                    </div>
                                    <div className='detalle-item' style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                        <strong>Total Final:</strong> {moneda} {Number(pedidoSeleccionado.total).toLocaleString('es-ES')}
                                    </div>
                                </>
                            ) : (
                                <div className='detalle-item'>
                                    <strong>Total:</strong> {moneda} {Number(pedidoSeleccionado.total).toLocaleString('es-ES')}
                                </div>
                            )}
                            <div className='detalle-item'>
                                <strong>Estado Pedido:</strong> {pedidoSeleccionado.estado}
                            </div>
                            <div className='detalle-item'>
                                <strong>Estado Cocina:</strong> 
                                <span style={{ 
                                    backgroundColor: getColorEstado(pedidoSeleccionado.estado_cocina),
                                    color: '#fff',
                                    padding: '4px 12px',
                                    borderRadius: '4px',
                                    marginLeft: '10px'
                                }}>
                                    {pedidoSeleccionado.estado_cocina}
                                </span>
                            </div>
                            <div className='detalle-productos'>
                                <h4>Productos:</h4>
                                {JSON.parse(pedidoSeleccionado.productos || '[]').map((item, index) => (
                                    <div key={index} className='producto-detalle'>
                                        <p><strong>{item.titulo}</strong> x {item.cantidad}</p>
                                        <p>Precio: {moneda} {Number(item.precio).toLocaleString('es-ES')}</p>
                                        {Array.isArray(item.items) && item.items.length > 0 && (
                                            <ul>
                                                {item.items.map((adicional, idx) => (
                                                    <li key={idx}>+ {adicional.name}</li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                ))}
                            </div>
                            {pedidoSeleccionado.nota && (
                                <div className='detalle-item'>
                                    <strong>Observaciones:</strong>
                                    <p>{pedidoSeleccionado.nota}</p>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </Modal>
        </div>
    );
}




